module.exports = __webpack_public_path__ + "media/images/empty-stomach-b4ee37415b9dcf079ad68aba45efa15f.svg";